import store from "@/store";

export default {
  getSurveyWeb(resultId) {
    return store.state.api.get(`begin/${resultId}`);
  },
  getSurveyWebReview(resultId) {
    return store.state.api.get(`review/${resultId}`);
  },
  getSurveyWebOpenPanel(word, questionKey=null) {
    if (questionKey != null){
      questionKey = encodeURIComponent(questionKey)
      return store.state.api.get(`begin/aaa?word=${word}&question_key=${questionKey}`);
    }
    return store.state.api.get(`begin/aaa?word=${word}`);
  },
  answerSurvey(listQuestions, sec, resultId) {
    let data = {
      questions: listQuestions,
      section: sec
    };
    return store.state.api.post(`answer/${resultId}`, data);
  },
  restartSurvey(resultId) {
    return store.state.api.get(`restart/${resultId}`);
  }
};
